export default __webpack_public_path__ + "static/media/Cars_22.44f0824a.png";